var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MediaUploadDialog',{attrs:{"open":_vm.open,"multiple":_vm.multiple,"selected-media":_vm.value,"accepted-file-types":_vm.mediaInputOptions,"active-tab":_vm.activeTab},on:{"input":_vm.onMediaSelected,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }